import { render, staticRenderFns } from "./SoporteTecnico.vue?vue&type=template&id=f0bd36cc&scoped=true"
import script from "./SoporteTecnico.vue?vue&type=script&lang=js"
export * from "./SoporteTecnico.vue?vue&type=script&lang=js"
import style0 from "./SoporteTecnico.vue?vue&type=style&index=0&id=f0bd36cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bd36cc",
  null
  
)

export default component.exports